<template>
  <div inline>
    <v-btn
      text
      @click="goBack()"
    >
      <v-icon>
        mdi-arrow-left
      </v-icon>
      <span v-if="title" class="h1"  v-html="title">
      </span>
    </v-btn>
    <v-divider
      class="mx-4"
      inset
      vertical
    />
  </div>
</template>

<script>
export default {
  props: ['backURL', 'title'],
  methods: {
    goBack() {
      if (this.backURL) { this.$router.push({ name: this.backURL }); } else { this.$router.go(-1); }
    },
  },
};
</script>
